// extracted by mini-css-extract-plugin
module.exports = {"body":"style__body__M1SUs","drawing":"style__drawing__kIbGg","page":"style__page__ZnV2L"};